module.exports = __webpack_public_path__ + "static/media/hw_shi_12.ae6653af.flv";